import ActionTypes from '../constants/action-types';
import { RootActionTypes } from '../../../stores/types';

export default function clearCatalogOptions(): RootActionTypes {
  return {
    type: ActionTypes.CLEAR_CATALOG_OPTIONS,
  };
}
